import { render, staticRenderFns } from "./LayoutGrid.vue?vue&type=template&id=6d50c96d&scoped=true&"
import script from "./LayoutGrid.vue?vue&type=script&lang=ts&"
export * from "./LayoutGrid.vue?vue&type=script&lang=ts&"
import style0 from "@/src/components/styles/utils.css?vue&type=style&index=0&id=6d50c96d&scoped=true&lang=css&"
import style1 from "./LayoutGrid.vue?vue&type=style&index=1&id=6d50c96d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d50c96d",
  null
  
)

export default component.exports